import React from "react";
import './ProjectInfoBlock.scoped.scss';
import {ProjectInfoBlock as ProjectInfoBlockModel} from "../../../../api-client";
import arrowIcon from "../../../../assets/images/svg/arrow-line-white.svg";
import {Image} from "../../../common";
import {cn, resultIf} from "../../../../utils";

type Props = ProjectInfoBlockModel;

const ProjectInfoBlock = ({title, background, html}: Props) => {
  const isGreen = background === "green";

  const icon = (
    <div className={cn("project-info-block__icon", isGreen ? "project-info-block__icon--green" : "project-info-block__icon--black")}>
      <Image
        className={cn("project-info-block__arrow", resultIf(isGreen, "project-info-block__arrow--flipped"))}
        src={arrowIcon}
        alt=""
      />
    </div>
  );
  const titleElement = <div className="project-info-block__title">{title}</div>;

  return (
    <div className={cn("project-info-block", isGreen ? "project-info-block--green" : "project-info-block--white")}>
      <div className="project-info-block__header">
        { isGreen ? <>{titleElement}{icon}</> : <>{icon}{titleElement}</> }
      </div>
      <div className="project-info-block__content" dangerouslySetInnerHTML={{__html: html}}/>
    </div>
  );
};

export default ProjectInfoBlock;
